// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2jsKi","list":"BalanceDue_list__3BNZr","listRow":"BalanceDue_listRow__D60vZ","total":"BalanceDue_total__1pXuZ"};